<template>
  <div v-if="!showSubPage">
    <back-route-hdr :back-mode="'static'"></back-route-hdr>

    <div class="mar-top mar-operate-btm reserve">
      <van-cell-group class="mar-btm">
        <template #title>
          <span>会议群组名称（{{formData.name.length}}/30 字）</span>
          <span class="text-danger">*</span>
        </template>
        <van-field v-model="formData.name" placeholder="请输入会议群组名称"
                   rows="1" autosize type="textarea" maxlength="30"></van-field>
      </van-cell-group>

      <van-cell-group>
        <template #title>
          <span>会议群组成员（{{formData.members.length}}人）</span>
        </template>
        <van-cell title="添加成员" icon="add-o" class="text-primary"
                  :clickable="true" @click="showSubPage=true"></van-cell>
        <van-cell v-for="user in formData.members" :key="user.userId" center>
          <template #title>
            <span class="color-box mar-rgt-10"
                  :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
            <span class="custom-title">{{user.name}}（{{user.employeeNumber || "无"}}）</span>
          </template>
          <template #right-icon>
            <van-icon name="clear" class="text-md" @click="removeUser(user)"></van-icon>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button type="primary" size="small" @click="submitInfo()">提交会议群组</van-button>
      </div>
    </div>
  </div>
  <div v-else>
    <choose-users :cur-data="formData.members" @change-info="receiveSubPageInfo"></choose-users>
  </div>
</template>

<script>
  import {checkRespCorrect, frontConfirm} from "../../../../tools/utils";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import ChooseUsers from '../meeting/subPages/ChooseUsers.vue'
  import {personalGroup} from "../../../../server"
  import routerMeta from "../../router/routerMeta";

  export default {
    components: {
      ChooseUsers
    },
    data() {
      return {
        psgId: "",
        formData: {
          name: "",
          members: []
        },
        showSubPage: false,
      }
    },
    computed: {},
    mounted() {
      this.psgId = this.$route.params.psgId;
      this.psgId && this.initData()
    },
    methods: {
      initData() {
        UILoader.load();
        personalGroup.queryList(this, {queryFilter: {selfCursor: this.psgId}}).then(({searchPersonalGroup: data = {}}) => {
          UILoader.unload();
          const {personalGroupEdges} = data;
          const [edge] = personalGroupEdges;
          this.formData = edge.personalGroup
        }).catch(err => {
          UILoader.unload();
          vtToast(err.message)
        })
      },
      receiveSubPageInfo(data) {
        if (data) {
          this.formData.members = data
        }
        this.showSubPage = false
      },
      removeUser(user) {
        frontConfirm({
          title: "删除确认",
          msg: `是否确认删除群组成员：${user.name}？`,
        }, () => {
          const idx = this.formData.members.findIndex(e => e.userId === user.userId);
          this.formData.members.splice(idx, 1);
        })
      },
      submitInfo() {
        if (!this.formData.name || !this.formData.name.trim()) {
          vtToast(`请填写会议群组名称！`);
          return;
        }
        if (this.formData.members.length > 100) {
          vtToast(`会议群组成员数量上限为100！`);
          return;
        }
        const destData = {
          name: this.formData.name,
          members: this.formData.members.map(u => u.userId)
        };
        personalGroup.savePersonalGroup(this, {
          psgId: this.psgId,
          req: destData
        }).then(({savePersonalGroup: resp = {}}) => {
          if (checkRespCorrect(resp, "保存失败")) {
            messageHdl({code: msgCode.SUCCESS});
            this.$router.push({name: routerMeta.personalGroup.name})
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      }
    }
  }
</script>

<style scoped>
</style>
